import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { LgdTextAreaModule, LgdTextModule } from "@tylertech/lgd-reactive-forms";
import * as components from "./components";
import * as services from "./services";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatDialogModule,
    MatToolbarModule,
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule,
    LgdTextModule,
    LgdTextAreaModule,
];

const exportedComponents = [
    components.NoteListComponent,
    components.NotesComponent
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
        LgdTextModule
    ],
    declarations: [
        ...exportedComponents,
        components.NoteComponent,
        services.NotesDialogComponent,
        components.SingleNoteComponent,
    ],
    exports: exportedComponents,
    providers: [
        services.NotesDialogService,
        services.NoteService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotesModule { }
